import { axiosJwt } from '@/shared/auth/axios-lib'
import { errorHandler } from '@/shared/errorHandler'

const api = `${process.env.VUE_APP_API_CREDENCIADOS_URL}${process.env.VUE_APP_API_PATH}`

export default {
    obterPorId(entregaId) {
        return axiosJwt
            .get(`${api}/credenciados/apoios/entregas/${entregaId}`)
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterEntregaAnexo(entregaAnexoId) {
        return axiosJwt
            .get(
                `${api}/credenciados/apoios/entregas/anexos/${entregaAnexoId}`,
                {
                    responseType: 'blob'
                }
            )
            .then(response => {
                return response.data
            })
            .catch(error => {
                return errorHandler(error)
            })
    },

    obterTimeLine(entregaId) {
        return axiosJwt
            .get(`${api}/credenciados/apoios/entregas/${entregaId}/timeline`)
            .then(response => {
                return response.data
            }).catch(error => {
                return errorHandler(error)
            })
    }
}
